import { Component, Input, OnChanges } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { DirectorySharedService } from "@org-common/lib/directory-shared/directory-shared.service";
import { PositionConfig } from "devextreme/animation/position";
import { ContentReadyEvent } from "devextreme/ui/popover";

// This is the one with person content tooltip - shown in auto-link html view only.
// MentionPersonComponent which is used by tributejs is in common without tooltip as we need org-common
// to get the person content tooltip and we don't want tooltip for tributejs selection.
@Component({
    selector: "adapt-display-mention-person",
    templateUrl: "./display-mention-person.component.html",
    standalone: false,
})
export class DisplayMentionPersonComponent implements OnChanges {
    @Input() public personId?: number;

    public person?: Person;
    public popoverInitialised = false;
    public popoverVisible = true;
    public popoverCancelHiding = false;
    public popoverPosition: PositionConfig = {
        my: "left top",
        at: "left bottom",
    };

    public constructor(
        private directorySharedService: DirectorySharedService,
    ) { }

    public ngOnChanges() {
        if (this.personId) {
            this.directorySharedService.promiseToGetPersonById(this.personId).then((person) => this.person = person);
        }
    }

    public onPopoverContentReady(e: ContentReadyEvent) {
        // these are similar to link-person.component.ts - same DX hack from support
        (e.component.content() as any).on("dxpointerleave", () => { this.popoverVisible = false; this.popoverCancelHiding = false; });
        (e.component.content() as any).on("dxpointerdown", (event: JQuery.Event) => {
            if (event.which !== 3) {
                setTimeout(() => { this.popoverVisible = false; this.popoverCancelHiding = false; }, 200);
            }
        });
        (e.component.content() as any).on("dxpointerenter", () => this.popoverCancelHiding = true);
    }

    public onPopoverHiding(e: any) {
        if (this.popoverCancelHiding) {
            e.cancel = true;
        }
    }
}
